<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.0709 22.5002L9.5 17M9.5 17L15.0709 11.4997M9.5 17L16.5006 17C19.8144 17 22.5007 14.3136 22.5006 10.9998L22.5006 9.5" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
